import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Header } from '../../../../components/Header/Header'
import { Title } from '../../../../components/Title/Title'
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import axiosInstance from '../../../../configs/axiosInstance';
import { kassaColumn } from './constants/getKassaColumn';
import { useFetchData } from '../../../../hooks/useFetchData';
import OrderGrid from '../../../../components/OrderGrid ';
import { Autocomplete, Box, Button, Stack, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import BalanceCard from '../../../../components/BalanceCard/BalanceCard';
import MonetizationOnRoundedIcon from '@mui/icons-material/MonetizationOnRounded';
import { Controller, useForm } from 'react-hook-form';

const Kassa = ({ pageTitle }) => {
  const [kassa, setKassa] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const { data, loading: kassaCategoryLoading } = useFetchData('/category/kassaCategory/')

  const USERTYPE = localStorage.getItem('userType');
  const navigate = useNavigate

  const { control } = useForm({
    defaultValues: {
      category: null,
    },
  });


  useEffect(() => {
    const fetchFilteredData = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get('/core/kassa/', {
          params: {
            category: selectedFilters?.category === 'Все' ? '' : selectedFilters?.category,
            page: page + 1,
          },
        });
        setKassa(response.data.results);
        setTotalRowCount(response.data.count);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching filtered data:', error);
        setLoading(false);
      }
    };

    fetchFilteredData();
  }, [selectedFilters, page, pageSize]);

  const sortOrderBy = (field, value) => {
    setSelectedFilters((prevState) => ({
      ...prevState,
      [field]: value,
    }));
    setPage(0)
  };


  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
  };

  const totalSum = kassa?.reduce((sum, item) => sum + (item.balance || 0), 0);

  const columns = kassaColumn()

  return (
    <div className='containerr'>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <Header initial='Касса' />
      <Title
        title='Касса'
        icon={<CurrencyExchangeIcon fontSize='meduim' />}
      />
      <div className="container-inner">
        <Stack direction="row" gap={2} mt={2.5}>
          <BalanceCard
            title="Общая сумма касс"
            value={totalSum}
            icon={MonetizationOnRoundedIcon}
            iconColor="#10B981"
          />
        </Stack>

        <div className='orders-card-wrapper'>
          <div className='orders-card-header'>
            <div className='courier-detail__btns'>
              {USERTYPE === 'Админ' && (
                <Button variant='black-contained' onClick={() => navigate('/kassa/add')}>
                  Новый касса +
                </Button>
              )}
              <Box width={250}>
                <Controller
                  name="category"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      options={data?.results || []}
                      getOptionLabel={(option) => option.name || ''}
                      value={value}
                      onChange={(event, newValue) => {
                        onChange(newValue);
                        sortOrderBy('category', newValue ? newValue.id : '');
                        setPage(0);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="По категории"
                          size="small"
                          fullWidth
                        />
                      )}
                      loading={kassaCategoryLoading}
                      isOptionEqualToValue={(option, value) => option?.id === value?.id} 
                    />
                  )}
                />

              </Box>
            </div>
          </div>

          <OrderGrid
            orders={kassa}
            columns={columns}
            size={pageSize}
            page={page}
            loading={loading}
            totalRowCount={totalRowCount}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
            usePagination={true}
          />
        </div>

      </div>
    </div>
  )
}

export default Kassa